import { formatDate } from "@angular/common";
import { ODataV4Adaptor, Query } from '@syncfusion/ej2-data';
import { ExcelExportProperties, GridComponent } from "@syncfusion/ej2-angular-grids";
import { TreeGridComponent } from "@syncfusion/ej2-angular-treegrid";
import { getCurrentDate } from "./date-functions";


let filteredColType: string;
export class CustomOdataV4Adaptor extends ODataV4Adaptor {
    currentColFilterType!: string;
    constructor() {
        super();
    }

    override beforeSend(args: any) {
        args.ajaxSettings.beforeSend = (req: any) => {
            const token: any = localStorage?.getItem('access_token');
            req.httpRequest.setRequestHeader("Authorization", `Bearer ${token}`)
        }
    }
}

export const updateFilterIcon = (args: any, grid: GridComponent | TreeGridComponent | any) => {
    let isFiltered = false;
    if (args?.requestType === 'filtering' || args?.requestType === 'searching' || args?.requestType === 'refresh') {
        isFiltered = grid?.filterSettings?.columns.length || (grid.searchSettings.key && grid.searchSettings.key.length) ? true : false;
        const gridElement = grid?.element;
        if (isFiltered) {
            gridElement?.getElementsByClassName('grid-filter-icon')[0]?.classList.add('filtered');
        } else {
            gridElement?.getElementsByClassName('grid-filter-icon')[0]?.classList.remove('filtered');
        }
    }
}


export const handleGridExcelExport = (grid: GridComponent, fileName: string) => {
    const dataSource = getExcelDataSource(grid);
    const excelExportProperties: ExcelExportProperties = {
        dataSource,
        hierarchyExportMode: 'Expanded',
        theme: { header: { bold: true, backColor: '#eeeeee', fontSize: 15 } },
        fileName: `${fileName}(${getCurrentDate()}).xlsx`,
    };
    grid.excelExport(excelExportProperties);
};
export const excelQueryCellInfo = (args: any) => {
    if (args.column.field === 'status' || args.column.field === 'reasonDescription') {
        args.style = {
            backColor: getStatusColor(args.value),
            fontColor: '#ffffff',
            bold: true
        };
    } else if (args.column.field.includes('OrderId')) {
        args.style = {
            bold: true
        };
    } else if (args.value && args.column.field.toLowerCase().includes('date')) { // to print out the date in Jun 7, 2024 format
      let date = new Date(args.value);
      args.value = date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
      args.style = { numberFormat: 'd MMM, y' };
    }
}

export const firstLetterUpperCase = (word: string) => {
    return word.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index == 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
}

export const getMaxId = (dataSource: any[]) => {
    if (dataSource && dataSource.length > 0) {
        return Math.max(...dataSource.map((item: any) => item.tempRowId));
    } else {
        return 0;
    }
}

const getStatusColor = (status: string) => {
    status = status.toLowerCase();
    if (['in progress', 'inprogress', 'delivery acknowledged'].includes(status)) {
        return '#199efd';
    } else if (['partially shipped', 'partiallyshipped',].includes(status)) {
        return '#FF7F50';
    }
    else if (['open', 'total', 'draft', 'unknown'].includes(status)) {
        return '#656363';
    } else if (['scheduled', 'ready to be shipped', 'order sent', 'pending approval', 'short shipment'].includes(status)) {
        return '#f3ae4b';
    } else if (['completed', 'delivered', 'closed', 'estimate approved'].includes(status)) {
        return '#479e47';
    } else if (['interrupted', 'cancelled', 'canceled', 'estimate rejected', 'damaged'].includes(status)) {
        return '#9e1414';
    } else if (['received in ln', 'received in ms', 'en route'].includes(status)) {
        return '#9399ff';
    } else if (['enroute'].includes(status)) {
        return '#0bf9b7';
    } else if (['exceptions', 'paused', 'wrong part'].includes(status)) {
        return '#ca7671';
    } else if (['shipped', 'awaiting payment', 'excess shipment'].includes(status)) {
        return '#f7a56c';
    }
    return null;
}

export const updateRow = (row: any) => {
    if (row.startDate) { row.startDate = formatDate(row.startDate, 'mediumDate', 'en'); }
    if (row.expiryDate) { row.expiryDate = formatDate(row.expiryDate, 'mediumDate', 'en'); }
    // if (row.startTime) { row.startTime = formatDate(row.startTime, 'medium', 'en'); }
    if (row.endDate) { row.endDate = formatDate(row.endDate, 'mediumDate', 'en'); }
    // if (row.endTime) { row.endTime = formatDate(row.endTime, 'medium', 'en'); }
    if (row.createdDate) { row.createdDate = formatDate(row.createdDate, 'mediumDate', 'en'); }
    if (row.CreatedDate) { row.CreatedDate = formatDate(row.CreatedDate, 'mediumDate', 'en'); }
    if (row.lastUpdatedDate) { row.lastUpdatedDate = formatDate(row.lastUpdatedDate, 'mediumDate', 'en'); }
}

export const getExcelDataSource = (grid: any) => {
    const selectedRecords = JSON.parse(JSON.stringify(grid.getSelectedRecords()));

    const data = selectedRecords.length && selectedRecords || grid.getCurrentViewRecords();
    const dataSource = JSON.parse(JSON.stringify(data));
    dataSource.map((row: any) => {
        updateRow(row);
    });
    return dataSource;
}

export const getXMLDataSource = (grid: any) => {
    const selectedRecords = JSON.parse(JSON.stringify(grid.getSelectedRecords()));

    const data = selectedRecords.length && selectedRecords || grid.getCurrentViewRecords();
    const dataSource = JSON.parse(JSON.stringify(data));
    dataSource.map((row: any) => {
        updateRow(row);
    });
    return dataSource;
}

// To fix the Excel filter issue in OData V4
export const gridActionBeginForFilteringOdataV4 = (args: any) => {
    if (args.requestType === "filtering") { // handle undefined or null values and convert them to empty strings ''
      let cols: any[] = args.columns;
      if(cols?.length) {
        cols.map(m => {
          m.properties.value = m.properties.value ?? '';
          return m;
        });
      }
    } else
    if (args.requestType === "filterchoicerequest" || args.requestType === "filtersearchbegin") {
        var filterfields = [];
        var objFilter = Object.keys(args.filterModel.existingPredicate);
        for (var i = 0; i < objFilter.length; i++) {
            filterfields.push(objFilter[i]);
        }
        filterfields.push(args.filterModel.options.field);
        args.query.distincts = [];
        args.query.select(filterfields);
    }
}

export const gridActionsForFiltering = (args: any, grid: any) => {
    if (args.requestType === "filterafteropen") {
        filteredColType = args.filterModel.isExcel ? 'Excel' : args.filterModel?.col?.filter?.type;
        // if ( filteredColType === 'Menu') {
        //     let autoCompleteElem = args.filterModel?.dlgObj?.element?.querySelector('.e-autocomplete');
        //     let autoCompleteInst : AutoComplete = autoCompleteElem.ej2_instances[0];
        //     if ( autoCompleteElem ) {
        //         autoCompleteInst.filtering = (f_args) => {
        //             f_args.preventDefaultAction = true;
        //           };
        //     }
        // }
    // } else
    // if (args.requestType === 'filterAfterOpen') {
    //   var autoCompleteInst =
    //     args.filterModel.dlgObj.element.querySelector('.e-autocomplete')
    //       .ej2_instances[0];
    //     autoCompleteInst.actionBegin = (args: any) => {
    //     args.cancel = true;
    //   };
    } else if (args.requestType === "filtering") { // handle undefined or null values and convert them to empty strings ''
      let cols: any[] = args.columns;
      if(cols?.length) {
        cols.map(m => {
          m.properties.value = m.properties.value ?? '';
          return m;
        });
      }
    } else {
        filteredColType = '';
    }
}

/** Load OData total count quickly ($count only — do not pull the full dataset). */
export const loadGridTotalCount = (dataManager: any, baseQuery?: any): Promise<number> => {
  if (!dataManager?.executeQuery) return Promise.resolve(0);
  // take(0) asks for count without transferring rows; never fall back to result.length.
  const q = (baseQuery?.clone?.() || new Query()).requiresCount().take(0);
  return dataManager.executeQuery(q)
    .then((res: any) => Number(res.count) || 0)
    .catch(() => 0);
};

/** Grid actions that change how many rows match (filters/search/refresh). */
export const GRID_COUNT_REFRESH_REQUESTS = ['filtering', 'searching', 'refresh'];

/**
 * Update footer total instantly from the count already returned with the grid data request.
 * Avoids a second OData round-trip (which made the footer feel laggy after filter/search).
 */
export const applyInfiniteGridTotalCount = (
  grid: any,
  setCount: (count: number) => void,
  requestType?: string,
  args?: any
): void => {
  if (!requestType || !GRID_COUNT_REFRESH_REQUESTS.includes(requestType)) return;

  const fromArgs = args?.count;
  if (fromArgs != null && Number.isFinite(Number(fromArgs))) {
    setCount(Number(fromArgs));
    return;
  }

  // Syncfusion sets maxPage from count even when count is 0 (unlike totalDataRecordsCount).
  const maxPage = grid?.infiniteScrollModule?.maxPage;
  const viewCount = grid?.getCurrentViewRecords?.()?.length ?? 0;
  if ((requestType === 'filtering' || requestType === 'searching') && viewCount === 0 && maxPage === 0) {
    setCount(0);
    return;
  }

  // Set when count > 0; Syncfusion skips assignment for a falsy count.
  const stored = Number(grid?.totalDataRecordsCount);
  if (Number.isFinite(stored) && stored > 0) {
    setCount(stored);
  }
};

/**
 * Mid-scroll prefetch for Syncfusion infinite scroll.
 * Prefetches early, hides spinner, and avoids Syncfusion cache-mode crashes.
 * Optional setTotalCount syncs the footer from data-ready (same response as the rows — no extra API).
 */
export const bindInfiniteScrollPrefetch = (
  grid: any,
  getTotalCount: () => number = () => 0,
  attempt = 0,
  setTotalCount?: (count: number) => void
): void => {
  if (!grid?.element) return;

  if (setTotalCount && !grid._infiniteCountBound && typeof grid.on === 'function') {
    grid._infiniteCountBound = true;
    grid.on('data-ready', (e: any) => {
      if (!e || e.requestType === 'infiniteScroll') return;
      if (e.count != null && Number.isFinite(Number(e.count))) {
        setTotalCount(Number(e.count));
      }
    });
  }

  if (grid._infinitePrefetchBound) return;

  const content = grid.element.querySelector('.e-content') as HTMLElement;
  if (!content || !grid.infiniteScrollModule) {
    if (attempt < 30) setTimeout(() => bindInfiniteScrollPrefetch(grid, getTotalCount, attempt + 1, setTotalCount), 100);
    return;
  }

  grid.enableInfiniteScrolling = true;
  grid.allowPaging = false;
  // enableCache + frozen columns can crash Syncfusion (getAttribute on undefined in getInfiniteRowIndex).
  if (grid.infiniteScrollSettings) {
    grid.infiniteScrollSettings.enableCache = false;
  }
  grid._infinitePrefetchBound = true;
  let pending = false;

  const hideInfiniteSpinner = () => {
    try { grid.hideSpinner?.(); } catch { /* ignore */ }
  };

  if (!grid._infiniteSpinnerHidden) {
    grid._infiniteSpinnerHidden = true;
    if (typeof grid.on === 'function') {
      grid.on('actionBegin', (args: any) => {
        if (args?.requestType === 'infiniteScroll') {
          hideInfiniteSpinner();
          setTimeout(hideInfiniteSpinner);
        }
      });
    }
  }

  const prefetch = () => {
    const mod = grid.infiniteScrollModule;
    if (pending || !mod || typeof mod.makeRequest !== 'function') return;

    const scrollable = content.scrollHeight - content.clientHeight;
    if (scrollable <= 0) return;

    // Prefetch once ~25% is scrolled, or when less than ~2 viewports remain.
    const ratio = content.scrollTop / scrollable;
    const remaining = scrollable - content.scrollTop;
    if (ratio < 0.25 && remaining > content.clientHeight * 2) return;

    const rows = (grid.getRows?.() || []).filter(
      (r: Element) => r.classList?.contains('e-row') && !r.classList?.contains('e-addedrow')
    );
    if (!rows.length) return;

    const rowIndex = parseInt(rows[rows.length - 1].getAttribute('data-rowindex') ?? `${rows.length - 1}`, 10);
    if (isNaN(rowIndex) || rowIndex < 0) return;

    const pageSize = grid.pageSettings.pageSize || 200;
    const prevPage = grid.pageSettings.currentPage;
    const nextPage = Math.ceil(rowIndex / pageSize) + 1;
    const total = getTotalCount() || 0;
    const maxPage = total > pageSize ? Math.ceil(total / pageSize) : (mod.maxPage || Number.MAX_SAFE_INTEGER);

    if (total > pageSize) mod.maxPage = maxPage;
    if (!nextPage || nextPage <= prevPage || nextPage > maxPage) return;

    pending = true;
    // Defer outside Syncfusion's scroll handler to avoid re-entrancy crashes.
    setTimeout(() => {
      try {
        if (!grid.getRows?.()?.length) {
          pending = false;
          return;
        }
        mod.isScroll = true;
        grid.pageSettings.currentPage = nextPage;
        mod.makeRequest({
          requestType: 'infiniteScroll',
          currentPage: nextPage,
          prevPage,
          startIndex: rowIndex + 1,
          direction: 'down'
        });
        hideInfiniteSpinner();
        setTimeout(hideInfiniteSpinner);
      } catch {
        /* ignore Syncfusion transient scroll errors */
      } finally {
        setTimeout(() => pending = false, 350);
      }
    }, 0);
  };

  content.addEventListener('scroll', prefetch, { passive: true });
};

